/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M11.25 18.3025c0 .4141.3358.7497.75.7497s.75-.3356.75-.7497V2.8701l6.2197 6.2169a.7502.7502 0 0 0 1.0606 0 .7494.7494 0 0 0 0-1.0602L12 0 3.9697 8.0268a.7494.7494 0 0 0 0 1.0602.7502.7502 0 0 0 1.0606 0L11.25 2.87v15.4325ZM2.25 21.0013a.7498.7498 0 0 0-.75-.7496.7498.7498 0 0 0-.75.7496C.75 22.6574 2.0932 24 3.75 24h16.5c1.6569 0 3-1.3426 3-2.9987a.7498.7498 0 0 0-.75-.7496.7498.7498 0 0 0-.75.7496c0 .8281-.6716 1.4994-1.5 1.4994H3.75c-.8284 0-1.5-.6713-1.5-1.4994Z"
  />,
  'Upload'
);
